import { ColorConstant } from '../constants';

const initialState = {};

export default (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case ColorConstant.SET_COLOR:
      return { ...state, detail: payload };
    case ColorConstant.SET_COLORS:
      return { ...state, list: payload };
    default:
      return state;
  }
};
